module.exports = __webpack_public_path__ + "img/lasagna.b3894715.jpg";